






































import { Component, Mixins } from 'vue-property-decorator'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import * as ApiPath from '@/tcw/constant/ApiPath'
import { ApiGeneralObjectArrayPayload } from '@/tcw/api/types'
import BasePage from '@/tcw/components/BasePage'
import DataGetComponent from '@/tcw/components/DataGetComponent'
import DataUpdateComponent from '@/tcw/components/DataUpdateComponent'
import ShouninRouteSteps from '../organisms/ShouninRouteSteps.vue'
import ShouninRouteLocalHeader from '@/components/settei/molecules/ShouninRouteLocalHeader.vue'

@Component({
  components: { TcwLayoutBasicTemplate, ShouninRouteLocalHeader, ShouninRouteSteps }
})
export default class ShouninRoutePage extends Mixins(BasePage, DataGetComponent) {
  private editMode = false
  private refreshFlg = false
  private teishutsuRireki: ApiGeneralObjectArrayPayload = []
  private isLock = false

  // 勤怠ロック中の提出情報があるかチェック
  get apiPath(): string {
    return ApiPath.Paths.TeishutsuRireki.get
  }
  get hasLock(): boolean {
    return this.teishutsuRireki.some(r => r.isLock)
  }
  protected get form(): DataUpdateComponent {
    return this.$refs.form as DataUpdateComponent
  }
  protected responseInitWebApi(response: ApiGeneralObjectArrayPayload): void {
    this.teishutsuRireki = response
  }

  protected async save(): Promise<void> {
    const answer = await this.$tcw.confirm({
      type: 'warning',
      title: '保存の確認',
      message: '承認ルートを保存しますか？'
    })
    if (!answer) {
      this.$tcw.message({
        type: 'error',
        message: '保存しませんでした'
      })
      return
    }
    await this.form.startSaveProc()
  }

  private endEditMode() {
    this.editMode = false
  }

  private async confirmCancel(): Promise<boolean> {
    return await this.$tcw.confirm({
      type: 'danger',
      title: '編集モードの終了',
      message: '入力された内容は保存されていません。入力を破棄して編集モードを終了しますか？'
    })
  }

  private async openCancelDialog() {
    const answer = await this.confirmCancel()
    if (answer) {
      const formComponent = this.$refs.form as ShouninRouteSteps
      formComponent.reset()
      this.editMode = false
    }
  }

  private changeEditMode(mode: boolean) {
    if (mode) {
      this.editMode = mode
    } else {
      this.openCancelDialog()
    }
  }

  private async beforeRouteLeave(to: any, from: any, next: any) {
    if (this.editMode) {
      const answer = await this.confirmCancel()
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
